import React, { useState, useContext } from "react";
import cartImg from "../img/Cart.svg";
import { ShopContext } from "../contexts/ShopContext";
export default function Cart() {
  const ShopCart = useContext(ShopContext);


  return (
    <div className="Cart" onClick={() =>{ShopCart.SetShowModal(true)}}>
      <img src={cartImg} alt="" srcset="" />
      <div className="CartAmount">{ShopCart.ShopCart.length}</div>
    </div>
  );
}
